/* eslint-disable no-use-before-define */
/* eslint-disable no-shadow */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import './index.css';
import iconError from '../../../assets/images/icone_advertencia.svg';

const BotError = () => {
  const [visible, setVisible] = useState(false);
  const visibleRef = useRef(null);

  const { itemsOnError } = useSelector((state) => state.botCreator);
  const { bot } = useSelector((state) => state.bots);

  useEffect(() => {
    document.addEventListener('click', onClickOutsideIcon);
    return () => {
      document.removeEventListener('click', onClickOutsideIcon);
    };
  });

  const onClickOutsideIcon = (event) => {
    if (visibleRef.current && !visibleRef.current.contains(event.target)) {
      setVisible(false);
    }
  };

  return (
    <div
      className="action-error-header"
      onClick={() => setVisible(!visible)}
      ref={visibleRef}
    >
      {(!!itemsOnError?.length || !!bot?.countUpdatesNoPublish) && (
        <img src={iconError} alt="Block Error Warning" />
      )}

      {visible && (
        <div className="container-seta-error">
          <div className="seta-cima" />
          <div className="container-error-tooltip-list">
            <ul>
              {bot?.countUpdatesNoPublish && (
                <li>
                  <span>{`${bot?.countUpdatesNoPublish} ${
                    (bot?.countUpdatesNoPublish > 1 &&
                      'Alterações não publicadas') ||
                    'Alteração não publicada'
                  } `}</span>
                </li>
              )}

              {itemsOnError.map((item) => (
                <li key={item._id}>
                  <span>{item.title}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default BotError;
